import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-surface-card dark:bg-surface-dark py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm text-gray-500 dark:text-gray-400">
          <Link to="/features/health-twin" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            How it works
          </Link>
          <Link to="/features/predictions" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Why trust it
          </Link>
          <Link to="/articles" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Articles
          </Link>
          <Link to="/about" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            About
          </Link>
          <Link to="/contact" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Contact
          </Link>
          <Link to="/privacy-policy" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Terms of Service
          </Link>
          <Link to="/delete-account" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Delete Account
          </Link>
        </div>
        <p className="mt-6 max-w-2xl mx-auto text-center text-xs leading-relaxed text-gray-400 dark:text-gray-500">
          Vegetablah offers wellness guidance, not medical advice. Its trends, targets, and
          suggestions describe your own data — they don't diagnose, treat, or replace a clinician.
          Talk to a healthcare professional before acting on anything here.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
